import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { IIdItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetDatasourceRefreshModeParams extends IIdItem {
  refreshMode: string;
}

export class SetDatasourceRefreshModeRequest extends Request<ISetDatasourceRefreshModeParams, IEmptyResult> {
  constructor(params: ISetDatasourceRefreshModeParams) {
    super('setDatasourceRefreshMode', params);
  }
}
